import { type Static, Type } from '@sinclair/typebox';
import { MongooseObjectIdOrStringSchema, MongooseRefSchema } from './common.dto.js';
import { ItemDTOSchema } from './item.dto.js';

export const ItemUserDTOSchema = Type.Object({
  _id: MongooseObjectIdOrStringSchema,
  item: MongooseRefSchema(ItemDTOSchema),
  user: Type.String(),
});
export type ItemUserSchema = Static<typeof ItemUserDTOSchema>;

export const ItemUserPodcastDTOSchema = Type.Intersect([
  ItemUserDTOSchema,
  Type.Object({
    listened: Type.Boolean(),
    position: Type.Number(),
  }),
]);
export type ItemUserPodcastDTO = Static<typeof ItemUserPodcastDTOSchema>;
